import 'react-toggle/style.css';
import styled from 'styled-components';

import { faCaretSquareDown, faCaretSquareUp } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import useDataSorter from 'src/CustomHooks/useDataSorter';
import { ItemCell, renderState } from './IntersystemsServices';
import IIntersystemsComponent from 'src/ServerEntities/IIntersystemsComponent';

const Table = styled.table`
    width: 100%;
`;

const ItemLine = styled.tr`
    display: flex;
    flex-direction: row;
    flex: 1 0 auto;
    width: 100%;
    justify-content: space-between;
`;

const OuterContainer = styled.div`
    border-radius: 25px;
    border: 5px solid #44A2D6;
    padding: 2px;
    flex: 1 1 auto;
`;

const InnerContainer = styled.div`
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
`;

const TitleBar = styled.div`
    border-radius: 20px;
    background-color: #1577AE;
    padding: 5px;
    color: #FFF;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
`;

const ItemHeaderCell = styled.td`
    text-align: center;
    padding: 0.1em;
    font-size: 0.9em;
    font-weight: bold;
    color: #1577AE;
`;

interface IProps {
    data: IIntersystemsComponent[]
};

export const intersystemsComponentToItem = (array: [string, string, number, number, number], index: number) => {
    return <ItemLine key={`intersystems-service-${index}-${[array[0]]}`}>
        <ItemCell width={"40%"} style={{ textAlign: "left" }} className={array[1] === "ERROR" ? "error" : ""} title={array[0]}>{array[0]}</ItemCell>
        <ItemCell width={"20%"}>{renderState(array[1])}</ItemCell>
        <ItemCell width={"20%"}>{array[2]}</ItemCell>
        <ItemCell width={"20%"}>{array[3]}</ItemCell>
    </ItemLine>;
};

const IntersystemsProcesses = (props: IProps) => {
    const { data } = props;
    const [sortByColumn, setSortByColumn] = React.useState(4);
    const [sortDescending, setSortDescending] = React.useState(true);

    const changeSortColumn = (columnIndex: number) => (event: React.SyntheticEvent) => {
        event.stopPropagation();
        if (columnIndex === sortByColumn) {
            setSortDescending(!sortDescending);
        } else {
            setSortDescending(true);
        }
        setSortByColumn(columnIndex);
    };

    const commpointToArray = (commpoint: IIntersystemsComponent, index: number): [string, string, number, number, number] => [
        commpoint.name,
        commpoint.state,
        commpoint.alerts,
        commpoint.waitingQueueSize,
        index
    ];

    const sortedData = data.map(commpointToArray).sort(useDataSorter(sortByColumn, sortDescending))

    const renderSort = () => {
        return sortDescending ? <FontAwesomeIcon icon={faCaretSquareUp} style={{ marginRight: "8px" }} /> : <FontAwesomeIcon icon={faCaretSquareDown} style={{ marginRight: "8px" }} />
    }

    return <OuterContainer>
        <TitleBar>Processes</TitleBar>
        <InnerContainer>
            <Table>
                <thead>
                    <ItemLine>
                        <ItemHeaderCell width={"40%"}></ItemHeaderCell>
                        <ItemHeaderCell width={"20%"}></ItemHeaderCell>
                        <ItemHeaderCell width={"20%"} onClick={changeSortColumn(2)}>Alerts {renderSort()}</ItemHeaderCell>
                        <ItemHeaderCell width={"20%"} onClick={changeSortColumn(3)}>Queue in {renderSort()}</ItemHeaderCell>
                    </ItemLine>
                </thead>
                <tbody>
                    {sortedData.map(intersystemsComponentToItem)}
                </tbody>
            </Table>
        </InnerContainer>
    </OuterContainer>;
};

export default IntersystemsProcesses;
